import { ZenUnitsEnum } from '../../zentility/_shared/_enums/zen-units.enum';

/**
 * The platform unit name for a gas unit as a bill prints it ("therms", "CCF",
 * "Dth", "MMBtu", …). The bill editor's unit dropdown binds by the platform
 * name (ZenUnitsEnum), so an extracted "therms" has to become "Th" or the
 * dropdown shows blank while the confidence dot says the unit was read.
 * Undefined for anything unrecognised: better a blank the user must fill in
 * than a silent 10x from guessing Dth for therms.
 */
export function platformGasUnitName(printed: string | null | undefined): ZenUnitsEnum | undefined {
  const key = printed?.trim().toUpperCase().replace(/\.$/, '');
  if (!key) return undefined;
  switch (key) {
    case 'TH': case 'THM': case 'THERM': case 'THERMS':
      return ZenUnitsEnum.Th;
    case 'DTH': case 'DKTH': case 'DEKATHERM': case 'DEKATHERMS': case 'DECATHERM': case 'DECATHERMS':
      return ZenUnitsEnum.Dth;
    case 'CCF': case 'HCF':
      return ZenUnitsEnum.Ccf;
    case 'MCF':
      return ZenUnitsEnum.Mcf;
    case 'MMBTU': case 'MMBTUS':
      return ZenUnitsEnum.MMBtu;
    case 'GJ': case 'GIGAJOULE': case 'GIGAJOULES':
      return ZenUnitsEnum.GJ;
    case 'M3': case 'M\u00b3': case 'CUBIC METERS': case 'CUBIC METRES':
      return ZenUnitsEnum.CubicMeters;
    default:
      return undefined;
  }
}
